.root {
  display: flex;
  justify-content: center;
  align-items: center;
}
